
import { defineComponent, PropType } from 'vue';
import Slide from '@/models/SlideModel';
import SlideItemButton from './SlideItemButton.vue';

export default defineComponent({
	name: 'slide-item',

	components: {
		SlideItemButton
	},

	props: {
		slide: {
			type: Object as PropType<Slide>,
			required: true
		}
	},

	emits: ['click-button-with-payload']
});
